// extracted by mini-css-extract-plugin
export default {"dashboardWrapper":"dash_dashboardWrapper__iCeZh"};